import { render } from "./GenericTableV2.vue?vue&type=template&id=41bf5847&scoped=true"
import script from "./GenericTableV2.vue?vue&type=script&lang=js"
export * from "./GenericTableV2.vue?vue&type=script&lang=js"

import "./GenericTableV2.vue?vue&type=style&index=0&id=41bf5847&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bf5847"]])

export default __exports__